import script from "./CallEnded.vue?vue&type=script&setup=true&lang=js"
export * from "./CallEnded.vue?vue&type=script&setup=true&lang=js"

import "./CallEnded.vue?vue&type=style&index=0&id=41d91504&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d91504"]])

export default __exports__